export const environment = {
  production: true,
  appInsights: {
    instrumentationKey: 'bcc64c62-ca15-451b-b027-eccc500a17b8'
  }
};
